module.exports = __webpack_public_path__ + "static/media/campus_11.55e98125.jpg";